import api from "./apiURL";

export async function getLabTestLookups() {
  const response = await api.get("/api/v1/lookup/labtests/get");
  return response.data;
}

export async function updateLabTestLookup(id, data) {
  const response = await api.patch(`/api/v1/lookup/labtests/${id}`, data);
  return response.data;
}

export async function createLabTestLookup(data) {
  const response = await api.post("/api/v1/lookup/labtests", data);
  return response.data;
}
